import groq from 'groq'

const frameBuilderServicePricesFragment = groq`
  backBoard,
  backBoardMinimum,
  productionFee,
  largeFrameProductionFee,
  cutWaste,
  customPassepartoutProductionFee,
  customPassepartoutPriceMultiplier,
`

const frameBuilderProductServicePricesFragment = groq`
  backBoard,
  backBoardMinimum,
  productionFee,
  largeFrameProductionFee,
  cutWaste,
  customPassepartoutProductionFee,
  customPassepartoutPriceMultiplier,
`

export const frameBuilderServicePricesObjectFragment = groq`
  "servicePrices": *[
    _type == "frameBuilderServicePrices" &&
    locale == $locale
  ][0] {
    ${frameBuilderServicePricesFragment}
  },
`

export const frameBuilderProductServicePricesObjectFragment = groq`
  "servicePrices": *[
    _type == "frameBuilderServicePrices" &&
    locale == $locale
  ][0] {
    ${frameBuilderProductServicePricesFragment}
  },
`
